export default __webpack_public_path__ + "static/media/B192.5824ad04.png";